import VDialogPW from '@voly/ui-components/src/v2/VDialogPW';
import VFormField from '@voly/ui-components/src/v2/VFormField.jsx';
import VInput from '@voly/ui-components/src/v2/VInput.jsx';
import { useState } from 'react';
import { translate } from 'src/app/project/features/translate/translate';

interface RenameCustomFieldGroupModalProps {
  groupName: string;
  onClose: () => void;
  onRename: (name: string) => void;
}

const RenameCustomFieldGroupModal = ({
  groupName,
  onClose,
  onRename,
}: RenameCustomFieldGroupModalProps) => {
  const [name, setName] = useState(groupName);
  const [isTouched, setIsTouched] = useState(false);

  const isEmpty = name.trim() === '';
  const errorText = isTouched && isEmpty ? translate('group_name_required') : undefined;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setIsTouched(true);
    setName(event.target.value);
  };

  const handleOpenChange = (details: { open: boolean }): void => {
    if (!details.open) {
      onClose();
    }
  };

  const handleOk = (): void => {
    onRename(name.trim());
  };

  return (
    <VDialogPW
      open
      onOpenChange={handleOpenChange}
      onOk={handleOk}
      onCancel={onClose}
      loading={false}
      saveButtonDisabled={isEmpty}
      title={translate('rename_group')}
      body={
        <VFormField
          label={translate('group_name')}
          helperText=""
          errorText={errorText}
          invalid={Boolean(errorText)}
        >
          <VInput
            placeholder={translate('group_name_placeholder')}
            value={name}
            onChange={handleChange}
          />
        </VFormField>
      }
      saveBtnText={translate('rename_group')}
    />
  );
};

export default RenameCustomFieldGroupModal;
